import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import FuturePaymentsList from './FuturePaymentsList'

export default function FuturePayments() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/future_payments" component={FuturePaymentsList} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}